import styled from 'styled-components';

import {
  titleColor,
  buttonBackground,
  informationText,
  titleBackground
} from '../../styles/colors';

export {
  Label,
  CancelButton,
  Input,
  ErrorMessage,
} from '../../elements';

export {
  TextArea
} from '../../elements/forms';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Banner = styled.h1`
  display: flex;
  flex: 1;
  background-color: #E1EFFF;
  color: #00518E;
  border-radius: 10px;
  padding: 15px;
  padding-left: 1rem;
  font-weight: bold;
  margin-bottom: 30px;
`;

export const TitleContainer = styled.div`
  height: 100px;
  border-radius: 16px;
  background-color: ${titleBackground};
  display: flex;
  margin-bottom: 80px;

  @media (max-width: 600px) {
    height: 60px;
  }
`;

export const Title = styled.div`
  color: ${buttonBackground};
  font-size: 2rem;
  font-weight: 700;
  align-self: center;
  margin-left: 32px;

  @media (max-width: 600px) {
    font-size: 1.3rem;
  }
`;

export const InstructionsTitle = styled.div`
  color: ${buttonBackground};
  font-size: 2rem;
  align-self: center;
  margin-left: 32px;

  @media (max-width: 600px) {
    font-size: 1.3rem;
  }
`;

export const SubTitle = styled.div`
  color: ${buttonBackground};
  font-size: 1.6rem;
  font-weight: 700;
`;

export const Button = styled.button`
  background-color: ${buttonBackground};
  color: white;
  border: 0px;
  border-radius: 4px;
  height: 37px;
  font-size: 0.9rem;
  font-weight: 500;
  width: 100%;
  margin-top: 12px;
`;

export const ButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 12px;
`;

export const Text = styled.div`
  color: #898989;
  margin-left: 32px;
`;